import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";
import { DIVISIONS } from "@/data/divisions";
import { useCms } from "@/lib/cms";

export const Footer = () => {
  const cms = useCms();
  const c = cms.contact || {};
  const f = cms.footer || {};
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A2540] text-slate-200 mt-24"
    >
      <div className="px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <span className="inline-flex w-12 h-12 rounded-lg bg-white items-center justify-center overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_business-nexus-54/artifacts/695zxc2t_WhatsApp%20Image%202026-06-09%20at%203.16.25%20PM.jpeg"
                  alt="Indo-Pacific Group"
                  className="h-11 w-11 object-contain"
                />
              </span>
              <span className="font-heading text-xl font-medium tracking-tight text-white">
                Indo-Pacific Group
              </span>
            </div>
            <p className="mt-5 text-sm text-slate-300 leading-relaxed max-w-sm">
              {f.description || "Connecting Industries. Building Futures. A diversified conglomerate operating across Healthcare, Automobile, Real Estate, IPG Sales and Legal Advisory."}
            </p>

            <div className="mt-8 flex gap-3">
              {[Linkedin, Twitter, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-colors"
                >
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-400">
              Divisions
            </p>
            <ul className="mt-5 space-y-3 text-sm">
              {DIVISIONS.map((d) => (
                <li key={d.slug}>
                  <Link
                    data-testid={`footer-link-${d.slug}`}
                    to={`/divisions/${d.slug}`}
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {d.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-400">
              Company
            </p>
            <ul className="mt-5 space-y-3 text-sm">
              {["About", "Leadership", "Careers", "Newsroom", "Sustainability"].map(
                (l) => (
                  <li key={l}>
                    <a href="#" className="text-slate-300 hover:text-white">
                      {l}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-400">
              Contact
            </p>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-2">
                <MapPin size={16} strokeWidth={1.5} className="mt-0.5" />
                {c.address || "D-404 Ansal Tanushree, NH-24 Mehrauli, Ghaziabad, Uttar Pradesh, India — 210002"}
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} strokeWidth={1.5} />
                {c.email || "ronniemehra69@gmail.com"}
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} strokeWidth={1.5} />
                {c.phone || "+91 93548 59598"}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Indo-Pacific Group. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
